module.exports = __webpack_public_path__ + "gt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gt.svg
// module id = 839
// module chunks = 0